<template>
    <div class="container-fluid">
        <el-row>
            <el-col :span="24" class="d-flex align-items-start justify-content-center">
                <img src="../assets/ERROR404.svg" class="img-fluid">
            </el-col>
            <el-col :span="24" class="d-flex align-items-start justify-content-center">
                <h4 style="color: #343a40; display:block">A página que você visitou não existe</h4>
            </el-col>
            <el-col :span="24" class="d-flex align-items-start justify-content-center">
                <p><a href="#/">Página inicial</a></p>
            </el-col>
        </el-row> 
    </div>   
</template>

<script>
export default {
    
}
</script>

<style>
    img{
        width: 35%;
    }

</style>